// extracted by mini-css-extract-plugin
export default {"InfoPair":"InfoPair_InfoPair__4LnTo","InfoKey":"InfoPair_InfoKey__DOD9V","InfoValue":"InfoPair_InfoValue__54G6c"};